export const FETCH_PROFILE = 'app/Profile/FETCH_PROFILE';
export const SAVE_PROFILE = 'app/Profile/SAVE_PROFILE';
export const SET_PROFILE_FIELD_VALUE = 'app/Profile/SET_PROFILE_FIELD_VALUE';
export const SET_PROFILE_FIELD_VALID = 'app/Profile/SET_PROFILE_FIELD_VALID';
export const DISMISS_SNACKBAR = 'app/Profile/DISMISS_SNACKBAR';
